// Main.tsx
import React, { useEffect } from "react";
import "../main/styles/index.less";
import { Button, Col, Layout, Row } from "antd";
import CarouselCom from "./components/carousel";
import Contask from "./components/Contask";
import Connews from "./components/ConNew";
import Confooter from "./components/Confooter";
import ConLeader from "./components/ConLeader";
import Conhead from "./components/Conhead";
import { get_all_visitor, visitor_create } from "../../services/visitor";
import { useSocket } from "../../utils/socketio/SocketWrapper";
import i18n from "../../i18n";

const { Content } = Layout;

const Main = () => {
  // api save ip
  useEffect(() => {
    getIP();
  }, []);

  const getIP = async () => {
    try {
      await fetch("https://api.ipify.org/?format=json", {
        method: "GET",
        redirect: "follow",
      })
        .then((response) => response.text())
        .then(async (result) => {
          const res = await visitor_create({
            user_ip: JSON.parse(result).ip,
          });
        })
        .catch((error) => console.error(error));
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    const sections = document.querySelectorAll(".content-section");
    const observerOptions = {
      threshold: 0.2, // แสดงเมื่อ 20% ของ element เข้าสู่ viewport
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible"); // เพิ่ม class 'visible' เพื่อแสดง animation
        }
      });
    }, observerOptions);
    sections.forEach((section) => {
      observer.observe(section); // สังเกตการณ์แต่ละ section
    });

    return () => {
      sections.forEach((section) => observer.unobserve(section)); // Cleanup เมื่อ component ถูก unmount
    };
  }, []);

  return (
    <Layout>
      <div key={i18n.language}>
        <Content
          className="content-section"
          style={{
            // height: "85vh", /
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Conhead />
        </Content>

        <Content className="content-section-carousel">
          <CarouselCom />
        </Content>
        <Content className="content-section">
          <Contask />
        </Content>
        <Content className="content-section">
          <ConLeader />
        </Content>
        <Content className="content-section">
          <Connews />
        </Content>
        <Content className="content-section" id="sectioncontact">
          <Confooter />
        </Content>
      </div>
    </Layout>
  );
};

export default Main;
